import dynamic from 'next/dynamic';

import View360Icon from '@/icons/duotone/view-360.svg';
import { FeaturedText } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeView360Props } from './types';

const ModalView360 = dynamic(() => import('@/molecules/modal-view360'), {
  ssr: true,
});

export const View360: FunctionComponent<TypeView360Props> = ({
  className = '',
  src,
  flat,
}: TypeView360Props) => (
  <FeaturedText
    Icon={View360Icon}
    text="Explora tu nueva casa en una vista 360º"
    className={className}
  >
    <ModalView360 type="button" src={src} flat={flat} />
  </FeaturedText>
);

View360.displayName = 'View360';
